// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  "Major":0,
  "Minor":4,
  "Patch":2,
  "PreReleaseTag":"transport-interventions.1",
  "PreReleaseTagWithDash":"-transport-interventions.1",
  "PreReleaseLabel":"transport-interventions",
  "PreReleaseNumber":1,
  "WeightedPreReleaseNumber":30001,
  "BuildMetaData":"",
  "BuildMetaDataPadded":"",
  "FullBuildMetaData":"Branch.feature-transport-interventions.Sha.4338696e5cb9eae71befffd85c3cc3f3ade7f836",
  "MajorMinorPatch":"0.4.2",
  "SemVer":"0.4.2-transport-interventions.1",
  "LegacySemVer":"0.4.2-transport-intervent1",
  "LegacySemVerPadded":"0.4.2-transport-interv0001",
  "AssemblySemVer":"0.4.2.0",
  "AssemblySemFileVer":"0.4.2.0",
  "FullSemVer":"0.4.2-transport-interventions.1",
  "InformationalVersion":"0.4.2-transport-interventions.1+Branch.feature-transport-interventions.Sha.4338696e5cb9eae71befffd85c3cc3f3ade7f836",
  "BranchName":"feature/transport-interventions",
  "EscapedBranchName":"feature-transport-interventions",
  "Sha":"4338696e5cb9eae71befffd85c3cc3f3ade7f836",
  "ShortSha":4338696,
  "NuGetVersionV2":"0.4.2-transport-interv0001",
  "NuGetVersion":"0.4.2-transport-interv0001",
  "NuGetPreReleaseTagV2":"transport-interv0001",
  "NuGetPreReleaseTag":"transport-interv0001",
  "VersionSourceSha":"f38bf0101613c02c37ffb6726e0bdb4dbf2dec22",
  "CommitsSinceVersionSource":1,
  "CommitsSinceVersionSourcePadded":"0001",
  "UncommittedChanges":44,
  "CommitDate":"2021-01-19"
}
;
export const BuildTime = '2021-02-17T02:52:05.266Z';
/* tslint:enable */
